import type { MenuItemProps } from '@base-ui/react';

import { Menu as BaseMenu } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Icon, type IconName } from '../Icon/Icon';
import { itemStyle, menuItemIconStyle } from './Menu.css';

export type Props = MenuItemProps & {
  icon?: IconName;
};

export const MenuItem = ({ children, icon, ...delegated }: Props) => {
  return (
    <BaseMenu.Item {...delegated} className={clsxs(itemStyle, delegated.className)}>
      {icon && <Icon className={menuItemIconStyle} name={icon} size={22} />}

      <span>{children}</span>
    </BaseMenu.Item>
  );
};
